const updateGenresLoading = (state, { payload: { loading } }) => {
	state.genresLoading = loading;
};

export default updateGenresLoading;
